import { request } from "./client";

const createIdempotencyKey = () => {
  if (window.crypto?.randomUUID) return window.crypto.randomUUID();
  return `${Date.now()}-${Math.random().toString(16).slice(2)}`;
};

const summarizeSessionResponse = (response) => {
  const data = response?.data || response;
  return {
    status: response?.status,
    hasData: !!data,
    onboardingSessionId: data?.onboarding_session_id,
    hasSessionToken: !!data?.session_token,
    expiresAt: data?.expires_at,
    hasLaunch: !!data?.launch,
    launchKeys: data?.launch ? Object.keys(data.launch) : [],
  };
};

const summarizeCompletePayload = (payload) => ({
  hasOnboardingSessionId: !!payload?.onboarding_session_id,
  hasSessionToken: !!payload?.session_token,
  hasAuthorizationCode: !!payload?.authorization_code,
  hasWabaId: !!payload?.session_info?.waba_id,
  hasPhoneNumberId: !!payload?.session_info?.phone_number_id,
  hasBusinessId: !!payload?.session_info?.business_id,
});

const summarizeErrorDetails = (error) => ({
  code: error?.details?.code || error?.details?.error_code || error?.details?.data?.code,
  hasDetails: !!error?.details,
  hasData: !!error?.details?.data,
  hasSessionToken: !!(error?.details?.session_token || error?.details?.data?.session_token),
  hasLaunch: !!(error?.details?.launch || error?.details?.data?.launch),
});

export const fetchWhatsAppOnboardingReadiness = async (tenantId) => {
  const endpoint = `/tenants/${tenantId}/whatsapp/onboarding-readiness`;

  // console.log("[WhatsAppReadiness] request", {
  //   method: "GET",
  //   endpoint,
  //   tenantId,
  //   payload: null,
  // });

  try {
    const response = await request(endpoint, { skipCache: true });
    // console.log("[WhatsAppReadiness] response", response);
    return response;
  } catch (error) {
    // console.error("[WhatsAppReadiness] error", {
    //   status: error?.status,
    //   message: error?.message,
    //   details: summarizeErrorDetails(error),
    // });
    throw error;
  }
};

export const createWhatsAppOnboardingSession = async (tenantId, { restartExisting = false } = {}) => {
  const endpoint = `/tenants/${tenantId}/whatsapp/onboarding-sessions`;
  const payload = { restart_existing: restartExisting };
  const idempotencyKey = createIdempotencyKey();

  // console.log("[WhatsAppOnboardingSession] request", {
  //   method: "POST",
  //   endpoint,
  //   tenantId,
  //   payload,
  //   idempotencyKey,
  //   hasIdempotencyKey: !!idempotencyKey,
  // });

  try {
    const response = await request(endpoint, {
      method: "POST",
      data: payload,
      headers: { "Idempotency-Key": idempotencyKey },
    });
    // console.log("[WhatsAppOnboardingSession] response", summarizeSessionResponse(response));

    return response;
  } catch (error) {
    // console.error("[WhatsAppOnboardingSession] error", {
    //   status: error?.status,
    //   message: error?.message,
    //   details: summarizeErrorDetails(error),
    // });

    throw error;
  }
};

export const fetchWhatsAppAccountStatus = async (tenantId) => {
  const endpoint = `/tenants/${tenantId}/whatsapp/account`;

  // console.log("[WhatsAppAccountStatus] request", {
  //   method: "GET",
  //   endpoint,
  //   tenantId,
  //   payload: null,
  // });

  try {
    const response = await request(endpoint, { skipCache: true });
    // console.log("[WhatsAppAccountStatus] response", {
    //   status: response?.data?.data?.status,
    //   stage: response?.data?.data?.stage,
    //   availableActions: response?.data?.data?.available_actions,
    //   requestId: response?.data?.request_id,
    // });
    return response;
  } catch (error) {
    // console.error("[WhatsAppAccountStatus] error", {
    //   status: error?.status,
    //   message: error?.message,
    // });
    throw error;
  }
};

export const completeWhatsAppOnboarding = async (tenantId, payload) => {
  const endpoint = `/tenants/${tenantId}/whatsapp/onboarding/complete`;

  // console.log("[WhatsAppCompleteOnboarding] request", {
  //   method: "POST",
  //   endpoint,
  //   tenantId,
  //   payload: summarizeCompletePayload(payload),
  // });


  try {
    const response = await request(endpoint, {
      method: "POST",
      data: payload,
    });
    // console.log("[WhatsAppCompleteOnboarding] response", {
    //   status: response?.status,
    //   message: response?.message,
    //   accountStatus: response?.data?.data?.status,
    //   stage: response?.data?.data?.stage,
    //   statusEndpoint: response?.data?.data?.status_endpoint,
    //   requestId: response?.data?.request_id,
    // });

    return response;
  } catch (error) {
    // console.error("[WhatsAppCompleteOnboarding] error", {
    //   status: error?.status,
    //   message: error?.message,
    //   details: summarizeErrorDetails(error),
    // });

    throw error;
  }
};

export const retryWhatsAppOnboarding = async (tenantId) => {
  const endpoint = `/tenants/${tenantId}/whatsapp/account/retry`;

  // console.log("[WhatsAppRetryOnboarding] request", {
  //   method: "POST",
  //   endpoint,
  //   tenantId,
  // });

  try {
    const response = await request(endpoint, {
      method: "POST",
    });
    // console.log("[WhatsAppRetryOnboarding] response", {
    //   status: response?.status,
    //   message: response?.message,
    //   accountStatus: response?.data?.data?.status,
    //   requestId: response?.data?.request_id,
    // });
    return response;
  } catch (error) {
    // console.error("[WhatsAppRetryOnboarding] error", {
    //   status: error?.status,
    //   message: error?.message,
    // });
    throw error;
  }
};
